// extracted by mini-css-extract-plugin
export var root = "container-module--root--+VZXJ";
export var white = "container-module--white--ZVzRD";
export var gray = "container-module--gray--EsePS";
export var exampleAppear = "container-module--example-appear--e8F8Q";
export var exampleAppearActive = "container-module--example-appear-active--gH-fT";